import React, { useEffect } from 'react';
import { SecurityBoundary, PermissionBoundary } from '@vehix/portal/lib/security';
import { logDataAccess } from '@vehix/portal/lib/security/audit';
import { SystemRole } from '@vehix/portal/types';
import { useAuth } from '@vehix/shared/admin/portal-bridge';
import { ZoneMapTab } from '@vehix/portal/features/admin/components/ZoneMapTab';

/**
 * Zone Map page (formerly the combined Zone Setup page that toggled
 * between Map and List). The List view now lives on its own /setup/zone-list
 * route — sidebar nav handles the switch instead of an in-page toggle.
 */
const ZoneSetupPage: React.FC = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      logDataAccess({
        resource: 'zone_setup',
        action: 'view',
        metadata: { page: 'setup-zones' }
      }).catch(() => {
        /* silent — audit logging should not surface errors */
      });
    }
  }, [user]);

  return (
    <SecurityBoundary
      requiredSystemRole={SystemRole.SUPER_ADMIN}
      auditPageAccess='setup-zones'
      tenantIsolation={false}
    >
      <div className='flex h-full w-full flex-col overflow-hidden'>
        <PermissionBoundary require={{ resource: 'users', action: 'manage' }}>
          <ZoneMapTab />
        </PermissionBoundary>
      </div>
    </SecurityBoundary>
  );
};

export default ZoneSetupPage;
